import { render, staticRenderFns } from "./ModalProposalHistory.vue?vue&type=template&id=059d4f1e&scoped=true"
import script from "./ModalProposalHistory.vue?vue&type=script&lang=js"
export * from "./ModalProposalHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalProposalHistory.vue?vue&type=style&index=0&id=059d4f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d4f1e",
  null
  
)

export default component.exports